export default "__VITE_ASSET__DjEhF$rm__"